<div class="pt-4" *ngIf="serverError !== null">
  <div class="alert alert-danger">
    Server Error: {{ serverError }}
  </div>
</div>

<div class="pt-4 pl-md-4 mb-6" *ngIf="serverError === null">
  <div class="row">
    <div class="col-md-3">
      <span class="float-left mt-2 text-muted" [class.cursor-pointer]="!(loadingScheduledEvents || refreshingScheduledEvents)"
            (click)="loadScheduledEvents(false)">
        <span class="mr-1" *ngIf="refreshingScheduledEvents">Refreshing...</span>
        <span data-feather="refresh-cw"></span>
      </span>
    </div>
    <div class="col-md-6">
      <p class="mt-2" *ngIf="timeFilter === 'now'"
         style="width:100%;text-align:center">
        <b>EVENTS HAPPENING NOW</b>
      </p>
      <div class="mb-3" *ngIf="timeFilter !== 'now'"
           style="width:100%;text-align:center">
        <span style="cursor:pointer;font-size:18px;"
              (click)="shiftDay(-1)">
          <b>&nbsp;&nbsp;&nbsp;&#8592;&nbsp;&nbsp;&nbsp;</b>
        </span>
        <b>{{ dateFilter.toDateString().toUpperCase() }}</b>
        <span class="calendar-toggle text-secondary ml-1 position-relative">
          <span (click)="toggleDisplayDatePicker()">
            <span data-feather="calendar"></span>
          </span>
          <span *ngIf="displayDatePicker">
          <ngb-datepicker #datePicker (dateSelect)="handleDateSelect($event)"
                          style="position: absolute;background-color: white"></ngb-datepicker>
          </span>
        </span>
        <span style="cursor:pointer;font-size:18px;"
              (click)="shiftDay(1)">
          <b>&nbsp;&nbsp;&nbsp;&#8594;&nbsp;&nbsp;&nbsp;</b>
        </span>
      </div>
    </div>
    <div class="col-md-3">
      <a href="#"
         routerLink="/events/scheduled/private-event/add"
         class="btn btn-sm btn-success float-right mb-2">Create Private Event</a>
    </div>
  </div>

  <div class="clearfix mb-2">
    <button class="btn btn-sm btn-outline-primary float-left mb-2 mr-2"
            style="height: 33px"
            role="button"
            [disabled]="loadingFiltersModalRequirements()"
            [class.disabled]="loadingFiltersModalRequirements()"
            (click)="openEditFiltersModal()">
      {{ loadingFiltersModalRequirements() ? 'Loading...' : 'Edit Filters' }}
    </button>
    <span *ngFor="let activeFilter of getActiveFilters()"
          class="filter-item mb-2 mr-2 cursor-pointer"
          (click)="openEditFiltersModal()">{{ activeFilter }}</span>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table" *ngIf="(!loadingScheduledEvents) && scheduledEvents && (scheduledEvents.length > 0)">

      <thead>
      <tr>
        <th scope="col">Time</th>
        <th scope="col">Event</th>
        <th scope="col" *ngIf="(locationService.getLocations() !== null) && (locationService.getLocations().length > 0)">Location</th>
        <th scope="col">Instructors</th>
        <th scope="col" *ngIf="timeFilter !== 'upcoming'">Check-ins / Reservations / Capacity</th>
        <th scope="col" *ngIf="timeFilter === 'upcoming'">Reservations / Capacity</th>
        <th scope="col" class="position-sticky" style="right:0;"></th>
      </tr>
      </thead>

      <tbody *ngFor="let scheduledEvent of scheduledEvents">
      <tr [class.event-cancelled]="scheduledEvent.is_cancelled">
        <td>
          <span class="text-nowrap">{{ timeStringFromISO8601(scheduledEvent.start_datetime, scheduledEvent.time_zone) }}</span> -
          <span class="text-nowrap">{{ timeStringFromISO8601(scheduledEvent.end_datetime, scheduledEvent.time_zone) }}</span>
          <span *ngIf="scheduledEvent.is_cancelled">&ndash; <b>Cancelled</b></span>
        </td>
        <td>
          <span *ngIf="isIncompletePrivateEvent(scheduledEvent)" class="text-danger">INCOMPLETE </span>
          <ng-container *ngIf="scheduledEvent.is_private">Private Event:</ng-container>
          {{ scheduledEvent.name }}
          <ng-container *ngIf="scheduledEvent.event_part_count > 1">
            (Part {{ scheduledEvent.event_part_number }} of {{ scheduledEvent.event_part_count }})
          </ng-container>
          <span *ngIf="scheduledEvent.event_type_status === EventTypeStatus.retired" class="text-danger">
            (Retired)
          </span>
          <span *ngIf="scheduledEvent.event_type_status === EventTypeStatus.draft" class="text-muted">
            (Draft)
          </span>
          <span *ngIf="scheduledEvent.roster_name">- {{ scheduledEvent.roster_name }}</span>
          <span *ngIf="scheduledEvent.occurrence_name">- {{ scheduledEvent.occurrence_name }}</span>
          <span *ngIf="(!scheduledEvent.occurrence_name) && scheduledEvent.customer_facing_name">- {{ scheduledEvent.customer_facing_name }}</span>
        </td>
        <td *ngIf="(locationService.getLocations() !== null) && (locationService.getLocations().length > 0)">
          {{ scheduledEvent.location_name }}
        </td>
        <td>
          <span placement="bottom"
                [ngbTooltip]="instructorsManuallyEdited(scheduledEvent) ? 'This event\'s instructors have been manually edited, and do not reflect the schedule\'s instructors.' : ''">
            <span *ngFor="let instructor of scheduledEvent.instructors; last as isLast">
              {{ instructor.first_name }} {{ instructor.last_name }}{{ instructor.is_sub ? ' (Sub)' : '' }}{{ isLast ? '' : ',' }}
            </span>
            <span *ngIf="scheduledEvent.instructors.length === 0" class="text-muted">
              None
            </span>
            <span *ngIf="instructorsManuallyEdited(scheduledEvent)">*</span>
          </span>
        </td>
        <td>
          <span placement="bottom"
                [ngbTooltip]="eventFullDueToSecondaryCapacity(scheduledEvent) ? 'Facility capacity or booking limit reached for this time slot.' : ''">
            <span *ngIf="timeFilter !== 'upcoming'">{{ scheduledEvent.check_in_count }} /</span>
            {{ scheduledEvent.reservation_count }} / {{ scheduledEvent.capacity }}
            <span *ngIf="eventFullDueToSecondaryCapacity(scheduledEvent)">*</span>
          </span>
        </td>
        <td class="table-button-cell text-right position-sticky" style="right:0;">
          <a [routerLink]="router.url + '/event/' + scheduledEvent.event_part_id.toString()"
             class="btn btn-outline-primary btn-sm bg-white-not-important">
            Open
          </a>
        </td>
      </tr>
      </tbody>

    </table>

    <table class="table" *ngIf="loadingScheduledEvents || !(scheduledEvents && (scheduledEvents.length > 0))">
      <thead>
      <tr>
        <th scope="col">Time</th>
        <th scope="col">Event</th>
        <th scope="col" *ngIf="(locationService.getLocations() !== null) && (locationService.getLocations().length > 0)">Location</th>
        <th scope="col">Instructors</th>
        <th scope="col" *ngIf="timeFilter !== 'upcoming'">Check-ins / Reservations / Capacity</th>
        <th scope="col" *ngIf="timeFilter === 'upcoming'">Reservations / Capacity</th>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td colspan="99">
          {{ loadingScheduledEvents ? 'Loading...' : 'No events' }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
